import React from 'react'

interface IconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * Custom Target Arrow icon (filled/selected state)
 * Updated from FIR-4972 - filled version with arrow detail
 */
export const TargetArrowIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 6.99916C11.0111 6.99916 10.0444 7.29241 9.22215 7.84182C8.3999 8.39122 7.75904 9.17212 7.3806 10.0857C7.00217 10.9994 6.90315 12.0047 7.09608 12.9746C7.289 13.9445 7.76521 14.8354 8.46447 15.5347C9.16373 16.234 10.0546 16.7102 11.0246 16.9031C11.9945 17.096 12.9998 16.997 13.9134 16.6186C14.827 16.2401 15.6079 15.5993 16.1573 14.777C16.7068 13.9548 17 12.9881 17 11.9992M13 3.05416C11.1461 2.84618 9.2733 3.21944 7.64079 4.12234C6.00827 5.02523 4.69667 6.41312 3.88743 8.09402C3.07818 9.77493 2.81128 11.6658 3.12365 13.505C3.43601 15.3442 4.31221 17.0409 5.63103 18.3604C6.94985 19.6799 8.64611 20.5569 10.4852 20.8702C12.3242 21.1835 14.2152 20.9176 15.8965 20.1092C17.5779 19.3008 18.9664 17.9899 19.8701 16.3578C20.7738 14.7258 21.148 12.8532 20.941 10.9992M15 8.99916V5.99916L18 2.99916V5.99916H21L18 8.99916H15ZM15 8.99916L12 11.9992M16 6L17.5 4.5V6L19.5 6.5L17.8996 8.09402L16.5 8.5L15.4154 8.09402L15.5 6H16ZM16 6L16.5 6.5M16.5 6.5H17.5L18 7.5L17 7.84182L16 7.5V7L16.5 6.5ZM11 11.9992C11 12.2644 11.1054 12.5187 11.2929 12.7063C11.4804 12.8938 11.7348 12.9992 12 12.9992C12.2652 12.9992 12.5196 12.8938 12.7071 12.7063C12.8946 12.5187 13 12.2644 13 11.9992C13 11.7339 12.8946 11.4796 12.7071 11.2921C12.5196 11.1045 12.2652 10.9992 12 10.9992C11.7348 10.9992 11.4804 11.1045 11.2929 11.2921C11.1054 11.4796 11 11.7339 11 11.9992Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Custom Target Arrow icon (outline/default state)
 * Updated from FIR-4956 - new SVG with stroke-width 1.5
 */
export const TargetArrowOutlineIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 6.99916C11.0111 6.99916 10.0444 7.29241 9.22215 7.84182C8.39991 8.39122 7.75904 9.17212 7.3806 10.0857C7.00217 10.9994 6.90315 12.0047 7.09608 12.9746C7.289 13.9445 7.76521 14.8354 8.46447 15.5347C9.16373 16.234 10.0546 16.7102 11.0246 16.9031C11.9945 17.096 12.9998 16.997 13.9134 16.6186C14.827 16.2401 15.6079 15.5993 16.1574 14.777C16.7068 13.9548 17 12.9881 17 11.9992M13 3.05416C11.1461 2.84618 9.2733 3.21944 7.64079 4.12234C6.00827 5.02523 4.69667 6.41312 3.88743 8.09402C3.07818 9.77493 2.81128 11.6658 3.12365 13.505C3.43601 15.3442 4.31221 17.0409 5.63103 18.3604C6.94985 19.6799 8.64611 20.5569 10.4852 20.8702C12.3242 21.1835 14.2152 20.9176 15.8965 20.1092C17.5779 19.3008 18.9664 17.9899 19.8701 16.3578C20.7738 14.7258 21.148 12.8532 20.941 10.9992M15 8.99916V5.99916L18 2.99916V5.99916H21L18 8.99916H15ZM15 8.99916L12 11.9992M11 11.9992C11 12.2644 11.1054 12.5187 11.2929 12.7063C11.4804 12.8938 11.7348 12.9992 12 12.9992C12.2652 12.9992 12.5196 12.8938 12.7071 12.7063C12.8946 12.5187 13 12.2644 13 11.9992C13 11.7339 12.8946 11.4796 12.7071 11.2921C12.5196 11.1045 12.2652 10.9992 12 10.9992C11.7348 10.9992 11.4804 11.1045 11.2929 11.2921C11.1054 11.4796 11 11.7339 11 11.9992Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Custom Workspace icon (filled state)
 * Box/tray with handle design to match Figma specs
 */
export const WorkspaceFilledIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.375 5.25L18.707 2.543C18.6143 2.44996 18.5041 2.37617 18.3828 2.32589C18.2614 2.2756 18.1313 2.24981 18 2.25H6C5.86866 2.24981 5.73857 2.2756 5.61724 2.32589C5.4959 2.37617 5.38571 2.44996 5.293 2.543L2.625 5.25C2.53157 5.34267 2.37647 5.49498 2.326 5.61652C2.27553 5.73805 2.2497 5.8684 2.25 6L2.25 19.125C2.25 20.228 2.89702 20.9997 4.00002 20.9997H20C21.103 20.9997 21.75 20.1697 21.75 19.0667L21.75 6C21.7503 5.8684 21.7245 5.73805 21.674 5.61652C21.6235 5.49498 21.4684 5.34267 21.375 5.25ZM6.1011 3.96926C6.27841 3.82743 6.4987 3.75016 6.72575 3.75016H17.2743C17.5013 3.75016 17.7216 3.82743 17.8989 3.96926L19.5 5.25H4.5L6.1011 3.96926ZM7.75 12.75C7.19772 12.75 6.75 12.3023 6.75 11.75V11.25V10.5C6.75 10.0858 7.08579 9.75 7.5 9.75C7.91421 9.75 8.25 10.0858 8.25 10.5V11.25H12.0155H15.75V10.5C15.75 10.0858 16.0858 9.75 16.5 9.75C16.9142 9.75 17.25 10.0858 17.25 10.5V11.75C17.25 12.3023 16.8023 12.75 16.25 12.75H7.75Z"
      fill={color}
    />
  </svg>
)

/**
 * Custom Workspace icon (outline state)
 * Box/tray with handle design to match Figma specs
 */
export const WorkspaceOutlineIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.375 5.25L18.707 2.543C18.6143 2.44996 18.5041 2.37617 18.3828 2.32589C18.2614 2.2756 18.1313 2.24981 18 2.25H6C5.86866 2.24981 5.73857 2.2756 5.61724 2.32589C5.4959 2.37617 5.38571 2.44996 5.293 2.543L2.625 5.25C2.53157 5.34267 2.37647 5.49498 2.326 5.61652C2.27553 5.73805 2.2497 5.8684 2.25 6L2.25 19.125C2.25 20.228 2.89702 20.9997 4.00002 20.9997H20C21.103 20.9997 21.75 20.1697 21.75 19.0667L21.75 6C21.7503 5.8684 21.7245 5.73805 21.674 5.61652C21.6235 5.49498 21.4684 5.34267 21.375 5.25ZM6.1011 3.96926C6.27841 3.82743 6.4987 3.75016 6.72575 3.75016H17.2743C17.5013 3.75016 17.7216 3.82743 17.8989 3.96926L19.5 5.25H4.5L6.1011 3.96926ZM4.75 19.5002C4.19772 19.5002 3.75 19.0525 3.75 18.5002V6.75016H20.25V18.5002C20.25 19.0525 19.8023 19.5002 19.25 19.5002H4.75Z"
      fill={color}
    />
    <path
      d="M15.75 11.2505L8.25 11.25V10.5C8.25 10.0858 7.91421 9.75 7.5 9.75C7.08579 9.75 6.75 10.0858 6.75 10.5V11.75C6.75 12.3023 7.19772 12.75 7.75 12.75H16.25C16.8022 12.75 17.25 12.3023 17.25 11.75V10.5C17.25 10.0858 16.9142 9.75 16.5 9.75C16.0857 9.75 15.75 10.0858 15.75 10.5V11.2505Z"
      fill={color}
    />
  </svg>
)
